/**
 * Generated runtime TestId mirror for frontend/src/pages/JobExecutions.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const JobExecutionsTestIds = {
  btnClearJobFilter: "btn-clear-job-filter",
  colDuration: "col-duration",
  colJobName: "col-job-name",
  colNode: "col-node",
  colStarted: "col-started",
  colStatus: "col-status",
  colTasks: "col-tasks",
  jobExecutionsPage: "job-executions-page",
  linkExec: (exec_id: string) => `link-exec-${exec_id}`,
  linkExecPrefix: () => "link-exec-" as TestIdPrefix,
  linkJob: (exec_jobId: string) => `link-job-${exec_jobId}`,
  linkJobPrefix: () => "link-job-" as TestIdPrefix,
  rowExec: (exec_id: string) => `row-exec-${exec_id}`,
  rowExecPrefix: () => "row-exec-" as TestIdPrefix
} as const;
